/* pp-ux.js: scroll reveals + gallery lightbox + spec hotspot sync.
   Loaded unconditionally from theme.liquid (rule 15). Progressive:
   without JS everything is visible; reduced-motion is respected in CSS. */
(function () {
  document.documentElement.classList.add("pp-js");

  /* Reveal on scroll: tag the design-system building blocks, stagger siblings. */
  var SEL = [".pp-hero .pp-hero-copy", ".pp-hero .pp-hero-media", ".pp-head", ".pp-row", ".pp-card", ".pp-anchor", ".pp-trio-card", ".pp-faq-item", ".pp-cta-card", ".pp-statement-line", ".pp-spec-row", ".pp-banner-media", ".product-card-wrapper", ".pp-deliv .pp-col", ".customer-gallery__card", ".pp-blog-card", ".pp-cat", ".pp-sb-stat", ".pp-sd-grid > div", ".pp-an-media", ".pp-an-row", ".pp-logos-head", ".pp-logos-cell", ".pp-clg-head", ".pp-clg-item", ".pp-pal-head", ".pp-pal-tile", ".pp-sb h2", ".pp-sb .pp-sb-lede", ".pp-pi-grid > *", ".pp-pi-chips", ".pp-ch-grid > *", ".pp-cf-card", ".pp-sr-head", ".pp-sr-card", ".pp-sr-soon-card", ".pp-sm-card", ".pp-ig-head", ".pp-ig-card", ".pp-ig-note", ".pp-pol-clause", ".pp-sh-grid > *", ".pp-pj-head", ".pp-cc-head", ".pp-cc-crit", ".pp-cc-tabs", ".pp-cv-us", ".pp-cv-them", ".pp-tl-head", ".pp-tl-tile", ".pp-pj-rail", ".pp-pm-head", ".pp-pm-col", ".pp-ans-copy", ".pp-ans-card", ".pp-fb-fig", ".pp-pb-rule", ".pp-pb-grid > *", ".pp-pmx-head", ".pp-pmx-card", ".pp-pmx-tablecard", ".pp-qb-card",".pp-ft-head",".pp-ft-tile",".pp-bl-head-copy",".pp-bl-feat",".pp-bl-card",".pp-bl-picks-card",".pp-bl-sechead",".pp-ar-hero-copy",".pp-ar-hero-media",".pp-ar-takeaways",".pp-ar-cta",".pp-au-hero-copy",".pp-au-hero-media",".pp-au-part",".pp-au-quote",".pp-au-figure"].join(",");
  var nodes = Array.prototype.slice.call(document.querySelectorAll(SEL));
  var groups = {};
  nodes.forEach(function (el) {
    var key = el.parentElement ? Array.prototype.indexOf.call(document.querySelectorAll("*"), el.parentElement) : 0;
    groups[key] = (groups[key] || 0) + 1;
    el.classList.add("pp-reveal");
    el.style.setProperty("--pp-reveal-delay", Math.min((groups[key] - 1) * 70, 420) + "ms");
  });
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    nodes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add("is-in"); } else { io.observe(el); }
    });
  } else {
    nodes.forEach(function (el) { el.classList.add("is-in"); });
  }
  /* pp reveal safety: nothing stays hidden if an observer never fires */
  setTimeout(function () {
    nodes.forEach(function (el) { if (!el.classList.contains("is-in")) el.classList.add("is-in"); });
  }, 1800);

  /* Lightbox for the install gallery. */
  var dlg = null;
  function openLightbox(src, alt) {
    if (!dlg) {
      dlg = document.createElement("dialog");
      dlg.className = "pp-lightbox";
      dlg.innerHTML = "<button type=\"button\" aria-label=\"Close\">&#10005;</button><img alt=\"\">";
      document.body.appendChild(dlg);
      dlg.querySelector("button").addEventListener("click", function () { dlg.close(); });
      dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
    }
    var img = dlg.querySelector("img");
    img.src = src; img.alt = alt || "";
    if (dlg.showModal) dlg.showModal();
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    /* Product gallery: our lightbox instead of Dawn's full-page media modal. */
    var mediaToggle = e.target.closest(".product__media-toggle");
    if (mediaToggle) {
      var wrap = mediaToggle.closest(".product__media-container, .product__media-item, li");
      var mimg = wrap ? wrap.querySelector(".product__media img, img") : null;
      if (mimg) {
        e.preventDefault();
        e.stopPropagation();
        var msrc = mimg.currentSrc || mimg.src;
        openLightbox(msrc.replace(/width=\d+/, "width=1600"), mimg.alt);
        return;
      }
    }
    /* Configurator option images zoom instead of toggling the option. */
    var optImg = e.target.closest(".pp-config .pp-opt-media img");
    if (optImg) {
      e.preventDefault();
      e.stopPropagation();
      var osrc = optImg.currentSrc || optImg.src;
      openLightbox(osrc.split("width=128").join("width=1200"), optImg.alt);
      return;
    }
    var card = e.target.closest(".customer-gallery__card");
    if (!card) return;
    var img = card.querySelector("img");
    if (!img) return;
    e.preventDefault();
    var src = img.currentSrc || img.src;
    openLightbox(src.replace(/width=\d+/, "width=1800"), img.alt);
  }, true);

  /* Card prices: the mono FROM label above the amount is the one treatment.
     Strip Dawn's inline "From" word on ranged prices so it never doubles. */
  Array.prototype.forEach.call(document.querySelectorAll(".product-card-wrapper .price .price-item"), function (n) {
    if (n.textContent.indexOf("From") !== -1) n.textContent = n.textContent.replace("From", "").trim();
  });

  /* Spec hotspots: hovering a numbered dot highlights its spec row and back. */
  function wire(dot) {
    var id = dot.getAttribute("data-row");
    var row = id ? document.getElementById(id) : null;
    if (!row) return;
    function on() { row.classList.add("is-hl"); dot.classList.add("is-hl"); }
    function off() { row.classList.remove("is-hl"); dot.classList.remove("is-hl"); }
    dot.addEventListener("mouseenter", on); dot.addEventListener("mouseleave", off);
    dot.addEventListener("focus", on); dot.addEventListener("blur", off);
    row.addEventListener("mouseenter", on); row.addEventListener("mouseleave", off);
  }
  Array.prototype.forEach.call(document.querySelectorAll(".pp-dot"), wire);
})();
